import Address from "./forms/contact/Address";
import BrandLogo from "../../assets/images/logos/newspace-logo.png";
import { Container } from "react-bootstrap";
import { Link } from "gatsby";
import React from "react";
import SiteMap from "./nav/SiteMap";

// import NewsletterForm from "./forms/NewsletterForm";

const Footer = () => {
  return (
    <footer>
      {/*
      <Container className="my-5">
        <h1 className="text-uppercase h bolder">Newsletter</h1>
        <NewsletterForm />
      </Container>
      */}
      <Container>
        <Address />
        <hr />
        <SiteMap />
      </Container>
      <Container className="text-center">
        <Link to="/" title="new.space - Home">
          <img className="brand-logo my-5" src={BrandLogo} alt="new.space" />
        </Link>
      </Container>
    </footer>
  );
};

export default Footer;
